<template>
  <div>
    <v-data-table ref="table" class="purtrak-table"  height="calc(100vh - 154px)"
        :items="users" :headers="headers"
        disable-pagination hide-default-footer calculate-widths fixed-header
        @dblclick:row="(e,info) => $router.push({name:'SettingsUsersEdit',params:{userId:info.item.userId}})">
      <template v-slot:header.action>
        <v-btn fab color="primary" small :to="{name:'SettingsUsersEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.permissions="{value}">
        {{value.includes('config.write')?'YES':''}}
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>User operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'SettingsUsersEdit',params:{userId:item.userId}}"><v-list-item-title>Update user</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{userId:item.userId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="user = item; showDelete = true"><v-list-item-title>Delete user</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <delete-object v-model="showDelete" :name="user.name + ' from this distillery'" @delete="performDeleteUser"/>
  </div>
</template>

<script>
export default {
  name: 'SettingsUsers',
  data() {
    return {
      users: [],
      user: {},
      showDelete: false,
      columns: [],
      headers: [{ text: 'NAME', value: 'name', width:'35%',sortable:true},
                { text: 'EMAIL', value: 'email' ,width:'40%',sortable:true},
                { text: 'CONFIGURATION', value: 'permissions' ,width:'20%',align:'center',sortable:false},
                { text: '' , value:'action', width:'5%', filterable:false,sortable:false,sortable:false,align:'center'}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      const results = await this.$apiCall(`query SettingsUsers {
                                              company {
                                                users {
                                                  userId,name,email,permissions
                                                }
                                              }
                                            }`,
                                           {});
      if (!results.error)
        this.users = results.data.company.users;
      this.loading = false;
    },
    async performDeleteUser() {
      this.loading = true;
      const results = await this.$apiCall(`mutation SettingsUsers($userId: String!) {
                                                companyUserDelete(userId:$userId)
                                              }`,
                                          {userId:this.user.userId});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        const index = this.users.findIndex(s => s.userId === this.user.userId);
        this.users.splice(index, 1);
        this.$store.commit('setError', {type:'success',message:`Deleted user ${this.user.name}`});
      }
    }
  }
}
</script>